import { create } from 'zustand';

/**
 * Globale store voor de gespreksdetail-drawer. Mirror van
 * order-detail-drawer-store: elke page kan `useCallDrawerStore.open(id)`
 * aanroepen om het gespreksdetail (opname, samenvatting, transcript) in een
 * side-drawer te openen.
 */
interface CallDrawerState {
  openCallId: string | null;
  open: (id: string) => void;
  close: () => void;
}

export const useCallDrawerStore = create<CallDrawerState>((set) => ({
  openCallId: null,
  open: (id) => set({ openCallId: id }),
  close: () => set({ openCallId: null }),
}));
